// src/graphql/mutations.ts
import { gql } from '@apollo/client';

export const SIGN_UP = gql`
  mutation SignUp(
    $username: String!
    $email: String!
    $phone: String!
    $password: String!
    $company: String
  ) {
    signUp(
      username: $username
      email: $email
      phone: $phone
      password: $password
      company: $company
    ) {
      token
      user {
        id
        username
        email
        role
        phone
        avatar
        company
      }
    }
  }
`;

export const SIGN_IN = gql`
  mutation SignIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      token
      user {
        id
        username
        email
        role
        phone
        avatar
        company
        isBlocked
      }
    }
  }
`;

export const SEND_CONFIRMATION_CODE = gql`
  mutation SendConfirmationCode($email: String!) {
    sendConfirmationCode(email: $email)
  }
`;

export const VERIFY_CONFIRMATION_CODE = gql`
  mutation VerifyConfirmationCode($email: String!, $code: String!) {
    verifyConfirmationCode(email: $email, code: $code)
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($email: String!, $newRole: String!) {
    updateUserRole(email: $email, newRole: $newRole) {
      id
      email
      username
      role
    }
  }
`;

export const GRANT_TEMPORARY_ACCESS = gql`
  mutation GrantTemporaryAccess(
  $email: String!
  $durationInHours: Int!
  $reason: String!
  ) {
    grantTemporaryAccess(
    email: $email
    durationInHours: $durationInHours
    reason: $reason
    ) {
      id
      email
      username
      accessExpiry
      reason
      grantedBy {  
        id
        username
        avatar
        email
      }
    }
  }
`;

export const REVOKE_ACCESS = gql`
  mutation RevokeAccess($email: String!) {
    revokeAccess(email: $email) {
      id
      email
      username
      accessExpiry
      grantedBy { 
        id
        username
        email
      }
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile(
    $id: ID
    $username: String!
    $email: String!
    $company: String
    $avatar: String
    $phone: String
    $adminComment: String # ✅ Добавлено
  ) {
    updateUserProfile(
      id: $id
      username: $username
      email: $email
      company: $company
      avatar: $avatar
      phone: $phone
      adminComment: $adminComment # ✅ Добавлено
    ) {
      id
      username
      email
      company
      avatar
      phone
      adminComment # ✅ Добавлено
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;

export const BLOCK_USER = gql`
  mutation BlockUser($email: String!) {
    blockUser(email: $email) {
      id
      username
      isBlocked
      email
      role
    }
  }
`;

export const UNBLOCK_USER = gql`
  mutation UnblockUser($email: String!) {
    unblockUser(email: $email) {
      id
      username
      isBlocked
      email
      role
    }
  }
`;

export const CREATE_USER_BY_ADMIN = gql`
  mutation CreateUserByAdmin(
    $username: String!
    $email: String!
    $phone: String!
    $password: String!
    $company: String
    $role: String
  ) {
    createUserByAdmin(
      username: $username
      email: $email
      phone: $phone
      password: $password
      company: $company
      role: $role
    ) {
      token
      user {
        id
        username
        email
        role
      }
    }
  }
`;

export const CREATE_NOTE = gql`
  mutation CreateNote(
    $title: String!
    $content: String!
    $image: String
    $previewImage: String
    $tags: [String!]
    $attachments: [AttachmentInput!]
  ) {
    newNote(
      title: $title
      content: $content
      image: $image
      previewImage: $previewImage
      tags: $tags
      attachments: $attachments
    ) {
      id
      title
      content
      image
      previewImage
      tags
      createdAt
      updatedAt
      attachments {
        id
        size
        filename
        contentType
      }
    }
  }
`;

export const UPDATE_NOTE = gql`
  mutation UpdateNote(
    $id: ID!
    $title: String!
    $content: String!
    $image: String
    $previewImage: String
    $tags: [String!]
    $attachments: [AttachmentInput!]
    $attachmentIdsToDelete: [ID!]
  ) {
    updateNote(
      id: $id
      title: $title
      content: $content
      image: $image
      previewImage: $previewImage
      tags: $tags
      attachments: $attachments
      attachmentIdsToDelete: $attachmentIdsToDelete
    ) {
      id
      title
      content
      image
      previewImage
      tags
      createdAt
      updatedAt
      attachments {
        id
        size
        filename
        contentType
      }
    }
  }
`;

export const DELETE_NOTE = gql`
  mutation DeleteNote($id: ID!) {
    deleteNote(id: $id)
  }
`;


export const TOGGLE_FAVORITE = gql`
  mutation ToggleFavorite($id: ID!) {
    toggleFavorite(id: $id) {
      id
      favoriteCount
      favoritedBy {
        id
      }
    }
  }
`;


export const LOGOUT = gql`
  mutation Logout {
    logout
  }
`;

// Установка контента для страницы
export const SET_PAGE_CONTENT = gql`
  mutation SetPageContent($page: PageType!, $content: ContentInput!) {
    setPageContent(page: $page, content: $content) {
      id
      page
      contentType
      videoUrl
      title
      description
      noteId
      createdAt
      updatedAt
    }
  }
`;

// Очистка контента страницы
export const CLEAR_PAGE_CONTENT = gql`
  mutation ClearPageContent($page: PageType!) {
    clearPageContent(page: $page)
  }
`;
